import { Component, OnInit } from '@angular/core';
import { SupportService } from '../rest_services/msHelpServices/support.service';
import { UserService } from '../rest_services/user.service';

@Component({
  selector: 'app-dash-support',
  templateUrl: './dash-support.component.html',
  styleUrls: ['./dash-support.component.css']
})
export class DashSupportComponent implements OnInit {

  lastTicketsLoading: boolean = true
  ticketsLoading: boolean = true

  tickets: any[] = []
  lastTickets: any[] = []
  groupedTickets: any[][] = [];
  currentStatus: number = 1; // Default status is 'OUVERT'
  statusMap: { [key: string]: number } = {
    'OUVERT': 1,
    'RESOLU': 2,
    'REPRIS': 3,
    'EN_COURS': 4,
    'EN_ATTENTE': 5,
    'CLOS': 6
  };

  statusLabels: string[] = Object.keys(this.statusMap);


  constructor(
    private supportService: SupportService,
    private userService: UserService
  ) { }

  ngOnInit(): void {
    this.loadLastRequests();
    this.loadTicketsByStatus(this.currentStatus);
  }

  loadLastRequests(limit: number = 5): void {
    this.lastTicketsLoading = true;
    this.supportService.getLastRequests(limit);
    this.supportService.lastRequestsSubject.subscribe(
      (response: any) => {
        if (response.status === '200') {
          this.lastTickets = response.lastTickets;
          this.fetchCreator(this.lastTickets);
        } else {
          console.error('Failed to load last requests');
        }
        this.lastTicketsLoading = false;
      },
      (error: any) => {
        console.error('There was an error!', error);
        this.lastTicketsLoading = false;
      }
    );
  }

  fetchCreator(list: any) {
    list.forEach((ticket: any) => {
      const userId = ticket.createdBy; // Assuming userId is the user UUID
      this.userService.getUserFilteredData(userId, ['fullName','avatar','company']).subscribe(
        (userData: any) => {
          if (userData) {
            ticket.avatar = userData.connected_user.user_avatar;
            ticket.creator = userData.connected_user.user_fullname;
            ticket.organisation = userData.connected_user.company_name;
          }
        },
        (error: any) => {
          console.error('Error fetching user data:', error);
          // Handle error if needed
        }
      );
    });
  }
  async loadTicketsByStatus(status: number) {
    this.ticketsLoading = true;
    try {
      const response: any = await this.getTicketsByStatus(status);
      if (response.status === '200') {
        this.tickets = response.ticketByStatus;
        this.fetchCreator(this.tickets);
        this.groupTickets();
      } else {
        console.error('Failed to load tickets');
      }
    } catch (error) {
      console.error('There was an error!', error);
    }
  }

  getTicketsByStatus(status: number): Promise<any> {
    return new Promise((resolve, reject) => {
      this.supportService.getTicketsByStatus(status).subscribe(
        (response: any) => {
          resolve(response);
        },
        (error: any) => {
          reject(error);
        }
      );
    });
  }

  formatTimeDifference(dateString: string): string {
    if (!dateString) {
      return '----';
    }

    const now = new Date();
    const date = new Date(dateString);
    date.setHours(date.getHours() - 1);
    if (isNaN(date.getTime())) {
      return '----';
    }

    const diffInMs = now.getTime() - date.getTime();

    const diffInMins = Math.floor(diffInMs / (1000 * 60));
    const diffInHours = Math.floor(diffInMins / 60);
    const diffInDays = Math.floor(diffInHours / 24);

    if (diffInMins < 60) {
      return `${diffInMins} min`;
    } else if (diffInHours < 24) {
      const hours = diffInHours;
      const minutes = diffInMins % 60;
      return `${hours} h ${minutes} min`;
    } else {
      return `${diffInDays} jrs`;
    }
  }
  groupTickets(): void {
    this.groupedTickets = [];
    for (let i = 0; i < this.tickets.length; i += 2) {
      this.groupedTickets.push(this.tickets.slice(i, i + 2));
    }
    this.ticketsLoading = false;
  }

  changeStatus(status: number): void {
    this.currentStatus = status;
    this.loadTicketsByStatus(status);
  }

}
